import { Injectable } from '@angular/core';
import { SkillGroup } from '../domain/skill-group';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../../environments/environment';
import { map, shareReplay, switchMap } from 'rxjs/operators';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SkillGroupService {
  private skillsRefresh = new BehaviorSubject<void>(undefined);
  private skillsRefresh$ = this.skillsRefresh.asObservable();

  readonly skillGroupsAllWithRemoved$ = this.skillsRefresh$.pipe(
    switchMap(() => this.httpClient.get<SkillGroup[]>(`${ environment.api }/skill`)),
    shareReplay(1),
  );

  readonly currentSkillGroups = this.skillGroupsAllWithRemoved$.pipe(
    map((skillGroups) =>
      skillGroups.map(skillGroup => ({
        ...skillGroup,
        skills: skillGroup.skills.filter(skill => !skill.isRemoved)
      })).filter(skillGroup => !skillGroup.isRemoved)
    )
  );

  constructor(private httpClient: HttpClient) { }

  refreshSkillGroups(): void {
    this.skillsRefresh.next();
  }

  addSkillGroup(newSkillGroup: { name: string }): Observable<{ msg:string }> {
    return this.httpClient.post<{ msg:string }>(`${ environment.api }/admin/skill-group`, newSkillGroup);
  }

  editSkillGroup(skillGroupId: number, editedSkillGroup: { name: string }): Observable<{ msg:string }> {
    return this.httpClient.put<{ msg:string }>(`${ environment.api }/admin/skill-group/${ skillGroupId }`, editedSkillGroup);
  }

  removeSkillGroup(skillGroupId: number): Observable<{ msg:string }> {
    return this.httpClient.delete<{ msg:string }>(`${ environment.api }/admin/skill-group/${ skillGroupId }`);
  }

  addSkill(skillGroupId: number, newSkill: { name: string }): Observable<{ msg: string }> {
    return this.httpClient.post<{ msg: string }>(`${environment.api}/admin/skill`, { ...newSkill, groupId: skillGroupId });
  }

  editSkill(skillId: number, editedSkill: { name: string }): Observable<{ msg:string }> {
    return this.httpClient.put<{ msg:string }>(`${ environment.api }/admin/skill/${ skillId }`, editedSkill);
  }

  removeSkill(skillId: number): Observable<{ msg:string }> {
    return this.httpClient.delete<{ msg:string }>(`${ environment.api }/admin/skill/${ skillId }`);
  }
}
